import React from 'react';
import DropdownInput from "components/forms/BasicFormFields/DropdownInput";
import Config from 'Config';
import {Message} from 'semantic-ui-react';
import {Beaker2LoginButton, getToken} from './Beaker2LoginButton';

/**
 * Custom dropdown that fetches active receipt product campaigns from Beaker2 API
 */
class ReceiptCampaignDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            loading: true,
            error: null,
            needsAuth: false
        };
    }

    componentDidMount() {
        this.fetchCampaigns();
    }

    fetchCampaigns = () => {
        const apiUrl = `${Config.WEBSITE_API_URL}admin/receipt-campaign/active`;
        const token = getToken();

        this.setState({loading: true});

        // Use fetch instead of ajaxUtils to avoid CORS issues with Beaker2
        fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? {'Authorization': 'Token: ' + token} : {})
            }
        })
            .then(response => {
                if (response.status === 401 || response.status === 403) {
                    throw Object.assign(new Error('Not authenticated'), {authError: true});
                }
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                const options = [
                    { key: '__clear__', text: '— None —', value: null },
                    ...data.map((campaign) => ({
                        key: campaign.id,
                        text: `[${campaign.id}] ${campaign.name}`,
                        value: campaign.id
                    }))
                ];

                this.setState({
                    options: options,
                    loading: false,
                    error: null,
                    needsAuth: false
                });
            })
            .catch(error => {
                console.error('Error fetching receipt campaigns:', error);
                this.setState({
                    options: [],
                    loading: false,
                    error: error.authError ? 'You must log in to Beaker2 to load receipt campaigns' : 'Failed to load receipt campaigns',
                    needsAuth: !!error.authError
                });
            });
    }

    handleTokenChange = (token) => {
        if (token) {
            this.fetchCampaigns();
        }
    }

    render() {
        return (
            <React.Fragment>
                <DropdownInput
                    {...this.props}
                    options={this.state.options}
                    loading={this.state.loading}
                    error={this.state.error ? true : false}
                />
                {this.state.error && (
                    <Message negative>
                        <p>{this.state.error}</p>
                    </Message>
                )}
                {this.state.needsAuth && (
                    <Beaker2LoginButton onTokenChange={this.handleTokenChange} />
                )}
            </React.Fragment>
        );
    }
}

export default ReceiptCampaignDropdown;



// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/ReceiptCampaignDropdown.jsx